import React from 'react';
import { Ico } from './ShellIcons';
import nv from './navigator.module.css';

const fmt = (n) => (n == null ? '' : Number(n).toLocaleString('en-US'));

// One section row of the Navigator (v8): key hint · icon tile · name + tags + description · count · tick, and the Home star.
export default function NavRow({ r, num, on, isHome, portalName, onPick, onPin }) {
  return (
    <div className={nv.nrw}>
      <button type="button" role="menuitemradio" aria-checked={on} data-nav-row data-test="shell-section-row" className={`${nv.nr} ${on ? nv.cur : ''} ${r.soon ? nv.soon : ''}`} onClick={() => onPick(r)}>
        <span className={nv.kn} aria-hidden="true">{num || ''}</span>
        <span className={nv.ic}><Ico name={r.icon} /></span>
        <span className={nv.tx}>
          <span className={nv.nm}>{r.label}
            {r.badge ? <span className={`${nv.tg} ${nv.tgNew}`}>{r.badge}</span> : null}
            {r.twice ? <span className={`${nv.tg} ${nv.tgTwice}`} title={`Also in ${r.twice} — Compare years exists in two worlds`}>↔</span> : null}
            {r.gated ? <span className={`${nv.tg} ${nv.tgLock}`}><Ico name="lock" />Admin</span> : null}
            {isHome ? <span className={`${nv.tg} ${nv.tgHome}`}>Home</span> : null}
          </span>
          {r.d ? <span className={nv.ds}>{r.d}</span> : null}
        </span>
        <span className={nv.rt}>
          {r.soon ? <span className={`${nv.tg} ${nv.tgSoon}`}>Soon</span> : (r.count != null ? <span className={`${nv.cn} ${r.tone === 'red' && r.count ? nv.red : ''}`}>{fmt(r.count)}</span> : null)}
          {on ? <Ico name="check" className={nv.tick} /> : null}
        </span>
      </button>
      {onPin ? (
        <button type="button" className={`${nv.star} ${isHome ? nv.starOn : ''}`} aria-pressed={isHome} data-test="shell-section-pin"
          aria-label={isHome ? `${r.label} is the Home of ${portalName} — click to clear` : `Make ${r.label} the Home of ${portalName}`}
          title={isHome ? 'Home — click to clear' : 'Make this the Home: the section this portal opens on'} onClick={() => onPin(r.key)}>
          <Ico name="star" />
        </button>
      ) : null}
    </div>
  );
}
